/**
 * @module AccountConstants
 * @requires keyMirror
 */

import keyMirror from 'keymirror';

export const ACCOUNT_TYPE_SAVINGS = 'savings';

/**
 * @const AccountConstants
 */
export default keyMirror({
  REQUEST_ACCOUNTS_LIST: null,
  REQUEST_ACCOUNTS_LIST_SUCCESS: null,
  REQUEST_ACCOUNT_DETAILS: null,
  REQUEST_ACCOUNT_DETAILS_SUCCESS: null,
  REQUEST_ACCOUNTS_LIST_ERROR: null,
  REQUEST_ACCOUNT_DETAILS_ERROR: null,
  REQUEST_TERMS_AND_CONDITIONS: null,
  REQUEST_ACCEPT_TC_SUCCESS: null,
  REQUEST_ACCOUNTS_RESET_ERROR: null,
  REQUEST_DANGER_PERIOD: null,
  REQUEST_REJIG_POT_DETAILS: null,
  REQUEST_DANGER_PERIOD_SUCCESS: null,
  REQUEST_REJIG_POT_DETAILS_SUCCESS: null,
  REQUEST_DANGER_PERIOD_ERROR: null,
  REQUEST_REJIG_POT_DETAILS_ERROR: null,
  SET_ACCOUNT: null,
  ACCOUNT_REORDER_ERROR: null,
  // REDIRECT_TO_PAGELEVELERROR: null,
  NAVIGATION_REFERENCE: null,
  REQUEST_RESET_REJIG_ICON: null,
  UPDATE_ACCOUNT_ORDER_AND_NICKNAME: null,
  RESORT_ACCOUNT: null,
});
